export default __webpack_public_path__ + "static/media/banner1-mobile.b26af21c.png";